import getConfig from 'next/config';

import { envName } from './const';

export function dashedEnvPath(name = envName) {
  return name && name !== 'pro' ? `-${name}` : '';
}

const envDebug = process.env.ENV_DEBUG; // 本地调试

const { publicRuntimeConfig } = getConfig();
/**
 * 云函数走原逻辑打包进去的APP_NAME,
 * 切后端部署后走 publicRuntimeConfig获取运行时环境变量
 * @returns
 */
export const getAppName = () => {
  // // debug时根据启动命令传入
  // if (envDebug) {
  //   return process.env.APP_NAME;
  // }
  // const _appName =
  // return _appName;
  // 运行时判断环境 boom.fat.tinman.cn 或者 boom-fat.cdsskj.com , 线上 boom.tinman.cn , boom.cdsskj.com
  if (typeof window !== 'undefined') {
    return (
      window.tenant?.toLowerCase() || publicRuntimeConfig.APP_NAME || process.env.APP_NAME || 'JOJO'
    );
  }
  if (envDebug) {
    return process.env.APP_NAME;
  }
  const _appName = publicRuntimeConfig.APP_NAME || process.env.APP_NAME;
  return _appName;
};

/**
 * 云函数走原逻辑打包进去的ENV_NAME,
 * 切后端部署后走 publicRuntimeConfig获取运行时环境变量
 * @returns
 */
export const getEnvName = () => {
  // debug时根据启动命令传入
  if (envDebug) {
    return process.env.ENV_NAME;
  }
  const _envName = publicRuntimeConfig.ENV_NAME || process.env.ENV_NAME || 'pro';
  return _envName;
};
